import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable()
export class ResponsivenessService {
  resolution: BehaviorSubject<Resolution> = new BehaviorSubject<Resolution>(
    '1920x969',
  );

  private availableResolutions: Resolution[] = [
    '640x360',
    '360x640',
    '768x1024',
    '1024x657',
    '1280x609',
    '1280x913',
    '1920x969',
  ];

  constructor() {
    this.determineResolution();
    const resolutionChanged$ = fromEvent(window, 'resize');

    resolutionChanged$.pipe(debounceTime(500)).subscribe(() => {
      this.determineResolution();
    });
  }

  private determineResolution(): void {
    const width = window.screen.availWidth;
    const height = window.screen.availHeight;

    const newResolution = `${width}x${height}` as Resolution;

    const knownResolution = this.availableResolutions.includes(newResolution);

    this.resolution.next(
      knownResolution
        ? newResolution
        : (this.closestResolution(width, height) as Resolution),
    );
  }

  private closestResolution(width, height) {
    if (width < 657) {
      return '360x640';
    } else if (width >= 657 && width < 1024) {
      return '768x1024';
    } else if (width >= 1024 && width < 1280) {
      return '1024x657';
    } else if (width >= 1280 && width < 1920) {
      if (height < 913) {
        return '1280x609';
      } else {
        return '1280x913';
      }
    } else {
      return '1920x969';
    }
  }
}

export type Resolution =
  | '640x360'
  | '360x640'
  | '768x1024'
  | '1024x657'
  | '1280x609'
  | '1280x913'
  | '1920x969';
